/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNavigationDown = createReactComponent("navigation-down", "IconNavigationDown", [
  [
    "path",
    {
      d: "M16.528 12.815l-4.528 -9.815l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463",
      key: "svg-0"
    }
  ],
  ["path", { d: "M19 16v6", key: "svg-1" }],
  ["path", { d: "M22 19l-3 3l-3 -3", key: "svg-2" }]
]);

export { IconNavigationDown as default };
//# sourceMappingURL=IconNavigationDown.js.map
